import React from "react";
import { ArrowUp, Mail } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="section-navy">
      <div className="mx-auto max-w-[1440px] px-5 py-10 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <div className="font-display text-sm font-bold tracking-[0.24em] text-white">KEIMYUNG UNIVERSITY</div>
            <p className="mt-1.5 max-w-md text-xs leading-relaxed text-slate-400">{t.footer_tagline}</p>
            <p className="mt-3 font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500">{t.footer_contact}</p>
            <a href="mailto:keimyung.ai@gmail.com" data-testid="footer-contact-email" className="mt-1 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.1em] text-blue-300 transition-colors hover:text-white">
              <Mail size={12} /> keimyung.ai@gmail.com
            </a>
          </div>
          <nav className="flex flex-wrap items-center gap-6 text-xs text-slate-400">
            <a href="/" data-testid="footer-home-link" className="transition-colors hover:text-blue-300">{t.nav_home}</a>
            <a href="/projects" data-testid="footer-projects-link" className="transition-colors hover:text-blue-300">{t.footer_gallery}</a>
            <a href="/auth" data-testid="footer-auth-link" className="transition-colors hover:text-blue-300">{t.nav_login}</a>
            <a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-blue-300">{t.footer_admin}</a>
          </nav>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{t.footer_rights}</p>
          <button
            data-testid="back-to-top-button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400 transition-all duration-300 hover:border-blue-400/50 hover:text-blue-300"
          >
            {t.footer_top} <ArrowUp size={12} />
          </button>
        </div>
      </div>
    </footer>
  );
}
